import React from 'react';
import cuid from 'cuid';

const useStatefulId = (providedId?: string) => {
  const [id] = React.useState(providedId || cuid());
  return providedId || id;
};

export default useStatefulId;
